
import { defineComponent, onMounted, ref, PropType, onUnmounted } from "vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import Modal from "@/Components/General/Modal.vue";
import onScan from "onscan.js";
import Button from "@/Components/Buttons/Button.vue";
import { Inertia } from "@inertiajs/inertia";
import type { ProductRemember } from "@/types/ProductRemember";
import route from "ziggy-js";
import { mdiLoading, mdiPlus, mdiMinus } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import Messages from "@/Components/General/Messages.vue";
import { debounce } from "lodash";
import ProductSelect from "@/Components/Product/ProductSelect.vue";
import { useForm } from "@inertiajs/inertia-vue3";
import ValidationFormErrors from "@/Components/Forms/ValidationFormErrors.vue";

export default defineComponent({
  layout: AppLayout,
  props: {
    remembers: {
      type: Object as PropType<ProductRemember[]>,
    },
    admin: {
      type: Boolean,
    },
    developer: {
      type: Boolean,
    },
  },
  setup(props) {
    const barcodeSim = ref("");
    const barcodeSimOpen = ref(false);

    const form = useForm({
      product_id: null,
    });

    const addProduct = () => {
      form.post(route("products.remember-to-order.store"), {
      preserveScroll:true,
        onSuccess: () => {
          form.product_id = null;
        },
      });
    };



    const simScan = () => {
      onScan.simulate(document, barcodeSim.value);
    };

    const removeProductLoading = ref(false);

    const removeProduct = (product_id: number) => {
      removeProductLoading.value = true;
      Inertia.delete(
        route("products.remember-to-order.destroy", { product: product_id }),
        {
          preserveScroll:true,

          onFinish: () => {
            removeProductLoading.value = false;
          },
        }
      );
    };

    const windowsSize = ref("sm");

    const checkSize = (event?: Event) => {
      windowsSize.value = "sm";

      if (window.innerWidth > 768) {
        windowsSize.value = "md";
      }

      if (window.innerWidth > 1080) {
        windowsSize.value = "lg";
      }
    };

    window.addEventListener("resize", debounce(checkSize, 250));

    checkSize();

    onMounted(() => {
      onScan.attachTo(document, {
        onScan: async (sCode: string, iQty: number) => {
          Inertia.post(route("products.remember-to-order.store"), {
            barcode: sCode,
          }, {
            preserveScroll:true,

          });
        },
        minLength: 4,
      });

      (window as any).onScan = onScan;
    });

    onUnmounted(() => {
      onScan.detachFrom(document);
    });

    const emptyListOpen = ref(false);
    const emptyListLoading = ref(false);

    const emptyList = () => {
      emptyListLoading.value = true;
      Inertia.delete(route("products.remember-to-order.empty"), {
        preserveScroll:true,

        onSuccess: () => {
          emptyListOpen.value = false;
        },
        onFinish: () => {
          emptyListLoading.value = false;
        },
      });
    };

    return {
      form,
      route,
      simScan,
      emptyList,
      addProduct,
      barcodeSim,
      mdiPlus,
      mdiMinus,
      mdiLoading,
      windowsSize,
      removeProduct,
      emptyListOpen,
      barcodeSimOpen,
      emptyListLoading,
      removeProductLoading,
    };
  },
  components: {
    Modal,
    Button,
    SvgIcon,
    Messages,
    ProductSelect,
    ValidationFormErrors,
  },
});
